module.exports = __webpack_public_path__ + "img/app.0b0b5820.png";